import Sidedrawer from "./Sidedrawer";
import styled from 'styled-components';

export const SidedrawerProducer = styled(Sidedrawer)`

`;
